module.exports = __webpack_public_path__ + "static/media/care_device_controller.7c3b0aa3.svg";